// extracted by mini-css-extract-plugin
module.exports = {"list-item":"list-item_list-item__1oXec"};